import { keepPreviousData } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { useGetV4ProductReportByDate } from "./v4ProductReportByDate";

type Params = {
  productId: string | number;
  filters?: ColumnFiltersState;
  search?: string;
  start?: Date;
  end?: Date;
  preStart?: Date;
  preEnd?: Date;
  group?: "day" | "week" | "month";
};

type Options = {
  enabled?: boolean;
};

export const useProductByDate = (
  { productId, filters = [], search, ...dates }: Params,
  { enabled = true }: Options = {},
) => {
  const byDateOptionsGetter = useGetV4ProductReportByDate();

  return {
    ...byDateOptionsGetter({
      filters: [
        {
          id: "product_id",
          value: { op: "=", value: productId },
        },
        ...filters,
      ],
      search,
      ...dates,
    }),
    enabled,
    placeholderData: keepPreviousData,
  };
};
